import Crear from "./Crear";
import Listado from "./Listado";

const paginas = { Crear, Listado };
export default paginas;
